import { forwardRef, useCallback, useImperativeHandle } from 'react';

import { Box } from '@chakra-ui/react';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';

import { ArrowDown1, ArrowUp1 } from 'assets/assetsV1/iconComponents';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';

export const AgGridSortingFilter = forwardRef((props: IFilterParams, ref) => {
  // expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => ({
    doesFilterPass(params: IDoesFilterPassParams) {
      return true;
    },

    isFilterActive() {
      return false;
    },

    getModel() {},

    setModel() {},
  }));

  const sortAsc = useCallback(() => {
    props.api.applyColumnState({
      state: [{ colId: props.column.getId(), sort: 'asc' }],
      defaultState: { sort: null },
    });
  }, [props.column, props.api]);

  const sortDesc = useCallback(() => {
    props.api.applyColumnState({
      state: [{ colId: props.column.getId(), sort: 'desc' }],
      defaultState: { sort: null },
    });
  }, [props.column, props.api]);

  const filterParams = props.colDef.filterParams?.filters ?? [];
  const isNumberType = filterParams.some((item) => item?.filter === 'agNumberColumnFilter');

  return (
    <Box>
      <ListItemComp
        padding="8px"
        onClick={sortAsc}
        cursor="pointer"
        title={isNumberType ? 'Sort Ascending' : 'Sort A - Z'}
        LeftComponent={() => (
          <Box h={6} w={6} display="flex" alignItems="center">
            <ArrowUp1 color="#666666 !important" boxSize="20px" />
          </Box>
        )}
        withoutBackground
        isBoldText={false}
        RightComponent={null}
        subTitle={null}
        subSubtitle={null}
        isDisabled={false}
        active={false}
      />
      <ListItemComp
        padding="8px"
        onClick={sortDesc}
        cursor="pointer"
        title={isNumberType ? 'Sort Descending' : 'Sort Z - A'}
        LeftComponent={() => (
          <Box h={6} w={6} display="flex" alignItems="center">
            <ArrowDown1 color="#666666 !important" boxSize="20px" />
          </Box>
        )}
        withoutBackground
        isBoldText={false}
        RightComponent={null}
        subTitle={null}
        subSubtitle={null}
        isDisabled={false}
        active={false}
      />
    </Box>
  );
});
